export type Gap = "none" | "xs" | "sm" | "md" | "lg" | "xl"

export const gapClasses: Record<Gap, string> = {
  none: "gap-0",
  xs: "gap-1",
  sm: "gap-2",
  md: "gap-3",
  lg: "gap-4",
  xl: "gap-6",
}
